import { AUTH_EMAIL_LOGIN, AUTH_PASSWORD_SHOW } from 'portal/constants/Routes';
import {
  buttonContainerStyles,
  ctaContainerStyles,
  linkButtonStyles,
  loginButtonStyles
} from 'auth/AuthStyles';
import { postData } from 'helpers/RequestHelper';
import AuthLayout from 'auth/AuthLayout';
import Button from '@opploans/button-component/Button';
import LinkButton from '@opploans/link-button-component/LinkButton';
import Loading from 'auth/Loading';
import OpenLetter from 'images/ContainerIcons/OpenLetter.svg';
import React, { useEffect } from 'react';

const paragraphStyle = {
  fontStyle: 'italic',
  textAlign: 'center',
  margin: '1rem 0'
};

const svgContainerStyles = {
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '2rem'
};

const emailContainerStyles = {
  textAlign: 'center',
  marginBottom: '1rem',
  fontWeight: 'bold',
  fontSize: '1.5rem'
};

function AuthPasswordResetConfirmation({ navigate }) {
  const [loading, setLoading] = React.useState(false);
  const [resendDisabled, setResendDisabled] = React.useState(true);
  const email = window.AppConfigState?.password_reset?.email;
  const [nextAttempt, setNextAttempt] = React.useState(
    new Date(window.AppConfigState?.password_reset?.next_attempt)
  );

  useEffect(() => {
    const delay = nextAttempt - new Date();
    if (delay > 0) {
      setResendDisabled(true);
      setTimeout(() => {
        setResendDisabled(false);
      }, delay);
    } else {
      setResendDisabled(false);
    }
  }, [nextAttempt]);

  const requestPasswordReset = async () => {
    const response = await postData({
      url: AUTH_PASSWORD_SHOW,
      body: {
        user: { email }
      }
    });
    if (response.data?.error) {
      window.toastr.error(response.data?.error);
    }
    if (response.data?.next_attempt) {
      setNextAttempt(new Date(response.data.next_attempt));
    }
    setLoading(false);
  };

  const onSubmit = async () => {
    setLoading(true);
    await requestPasswordReset();
  };

  return (
    <AuthLayout
      title='Check Your Email'
      subTitle='Thanks! We sent you a password reset email to:'
      subHeaderStyles={{ textAlign: 'center' }}
    >
      {!email && <Loading /> /* maybe redirect to failure page? */}
      {email && (
        <>
          <div css={emailContainerStyles}>{email}</div>
          <div css={svgContainerStyles}>
            <OpenLetter />
          </div>
          <div css={buttonContainerStyles}>
            <Button
              loading={loading}
              onClick={onSubmit}
              css={loginButtonStyles}
              disabled={resendDisabled}
            >
              Resend Email
            </Button>
          </div>
          <p css={paragraphStyle}>
            This password reset link will expire in 30 minutes
          </p>
          <p css={paragraphStyle}>
            {' '}
            If you don&apos;t get an email within 5 minutes check your spam
            folder and ensure the email address is correct.{' '}
          </p>
        </>
      )}
      <div>
        <div css={ctaContainerStyles}>
          <LinkButton
            lightBackground
            additionalStyle={linkButtonStyles}
            onClick={() => navigate(AUTH_EMAIL_LOGIN)}
          >
            Return to Login
          </LinkButton>
        </div>
      </div>
    </AuthLayout>
  );
}

export default AuthPasswordResetConfirmation;
